// eslint-disable-next-line import/prefer-default-export
export const LINKEDIN_COLOR = '#4875b4';

export function getLinkedinConfig() {
  return {
    color: LINKEDIN_COLOR,
  };
}
